/**
 * Color blind filters Readiant can apply to a document.
 */
export const USER_SETTINGS_COLOR_BLIND_FILTERS = [
	"Grayscale",
	"Protonopia",
	"Protanomaly",
	"Deuteranopia",
	"Deuteranomaly",
	"Tritanopia",
	"Tritanomaly",
	"Achromatopsia",
	"Achromatomaly",
] as const;

/**
 * Reading orientations Readiant supports.
 */
export const USER_SETTINGS_ORIENTATIONS = ["landscape", "portrait"] as const;

/**
 * Fonts Readiant can render a document in.
 */
export const USER_SETTINGS_FONTS = [
	"Original",
	"Dyslexia",
	"Lora",
	"Merriweather",
	"Mulish",
	"Mukta",
	"Roboto",
] as const;

/**
 * Every persisted user setting, in the order they are stored and returned.
 */
export const USER_SETTINGS_FIELDS = [
	"colorBlindFilter",
	"countdownLevel",
	"font",
	"fontSize",
	"letterSpacing",
	"lineHeight",
	"orientation",
	"readStopLevel",
	"screenModeLevel",
	"subtitleLevel",
	"subtitleFontSize",
	"textModeLevel",
	"wordSpacing",
	"zoomLevel",
] as const;
